import styles from './PlatformProfileLayout.module.css';

export function PlatformProfileSkeleton() {
  return (
    <div className={styles.page}>
      {/* Banner placeholder */}
      <div className={styles.heroBannerSkeleton} aria-hidden="true">
        <div className={styles.heroContentSkeleton}>
          <div className={`${styles.skel} ${styles.skelBack}`} />
          <div className={styles.heroMainSkeleton}>
            <div className={`${styles.skel} ${styles.skelLogo}`} />
            <div className={styles.heroInfoSkeleton}>
              <div className={`${styles.skel} ${styles.skelTitle}`} />
              <div className={`${styles.skel} ${styles.skelFacts}`} />
            </div>
          </div>
          {/* 4 stat widget skeletons */}
          <div className={styles.widgetRowSkeleton}>
            {[0, 1, 2, 3].map((i) => (
              <div key={i} className={`${styles.skel} ${styles.skelWidget}`} />
            ))}
          </div>
        </div>
      </div>
      {/* Tab bar placeholder */}
      <div className={`${styles.skel} ${styles.skelTabBar}`} aria-hidden="true" />
      {/* Chart placeholder */}
      <div className={`${styles.skel} ${styles.skelChart}`} aria-hidden="true" />
    </div>
  );
}
